import React from 'react';
import { MagnifyingGlassIcon, XMarkIcon } from '@heroicons/react/24/outline';

interface PatientSearchBarProps {
  value: string;
  onChange: (v: string) => void;
  onClear: () => void;
  minLen: number;
  loading: boolean;
  placeholder?: string;
}

export const PatientSearchBar = ({
  value,
  onChange,
  onClear,
  minLen,
  loading,
  placeholder = 'Search patients...',
}: PatientSearchBarProps) => (
  <div className='px-2 mb-3'>
    <label htmlFor='patient-search' className='sr-only'>Search patients</label>
    <div className='relative group'>
      <MagnifyingGlassIcon className='h-4 w-4 text-gray-400 absolute left-3 top-1/2 -translate-y-1/2 pointer-events-none' />
      <input
        id='patient-search'
        type='text'
        value={value}
        onChange={e => onChange(e.target.value)}
        placeholder={placeholder}
        autoComplete='off'
        className='w-full pl-9 pr-8 py-2.5 text-sm rounded-lg border border-gray-300 bg-white focus:ring-2 focus:ring-brand-navy/40 focus:border-brand-navy placeholder:text-gray-400 shadow-sm'
      />
      {value && (
        <button
          onClick={onClear}
          className='absolute right-2 top-1/2 -translate-y-1/2 p-1 rounded-full text-gray-400 hover:text-gray-600 hover:bg-gray-100 focus:outline-none focus:ring-2 focus:ring-brand-navy/40'
          aria-label='Clear search'
        >
          <XMarkIcon className='h-4 w-4' />
        </button>
      )}
    </div>
    {value.length > 0 && value.length < minLen && (
      <div className='mt-1 ml-1 text-[10px] text-gray-400'>
        Type {minLen - value.length} more character{minLen - value.length === 1 ? '' : 's'}...
      </div>
    )}
    {loading && value.length >= minLen && (
      <div className='mt-1 ml-1 text-[10px] text-brand-navy' aria-live='polite'>Searching...</div>
    )}
  </div>
);
